import { mapGetters } from 'vuex'
import { menuHeight } from '@/helpers/view-constatns'
export default {
  data() {
    return {
      currentScroll: 0,
      lastScroll: 0,
      scrollTop: 0,
      isScrollingDown: false,
      visibleElement: '',
    }
  },
  computed: {
    ...mapGetters({
      offsets: 'getOffsets',
    }),
    isVisible() {
      return (
        this.scrollTop > 100 &&
        this.$store.getters.getOffsets.ElectronicOverhead <=
          this.currentScroll + menuHeight()
      )
    },
  },
  mounted() {
    this.scrollHandler()
    document.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollHandler)
  },
  methods: {
    // получение текущего скролла документа при прокрутке
    scrollHandler() {
      this.visibleElement = ''
      const menu = this.menu.menuItems

      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop

      this.isScrollingDown = this.scrollTop > this.lastScroll
      this.lastScroll = this.scrollTop

      this.currentScroll = this.scrollTop + menuHeight() + 1

      for (let i = 0; i < menu.length - 1; i++) {
        if (
          this.currentScroll > this.offsets[menu[i].component] &&
          this.currentScroll < this.offsets[menu[i + 1].component]
        ) {
          this.visibleElement = menu[i].component
          break
        }
      }

      if (!this.visibleElement.length) {
        this.visibleElement = 'FooterComponent'
      }
      // костыль для перехода активного пункта меню на Контакты (футер не скроллится до верха страницы)
      if (
        this.visibleElement === 'FreePeriod' &&
        this.currentScroll - this.offsets.FreePeriod > 500
      ) {
        this.visibleElement = 'FooterComponent'
      }
    },
  },
}
